module.exports = __webpack_public_path__ + "./docs/img/icon-twitter-gray.e678e5545d21c6943fbb784bd5285ade.svg";